/* eslint-disable react/no-unused-prop-types */
import { useAppScrollRef } from '@doltech/core/lib/appScroll/withAppScroll';
import * as React from 'react';
import styled from 'styled-components';
import { ResponsiveTypography } from '../../../../Typography/v3/ResponsiveTypography';

import { BlogSticky } from '../../../../Blog/BlogSticky';
import { Box } from '../../../../Common/BoxV2';
import { ContentItemGroup } from './ContentItemGroup/ContentItemGroup';
import { ContentItemGroupWithEditor } from './ContentItemGroupWithEditor/ContentItemGroupWithEditor';
import { ContentItemProps, TableOfContentProps } from './TableOfContentType';
import { TocContentLayout } from './TocContentLayout/TocContentLayout';

const Main = styled.div.withConfig({
  componentId: 'TableOfContent_Main',
} as any)``;
const BlogStickyTOCWrapper = styled(Main)`
  .dol-editor {
    .editor-content-wrapper {
      .editor-editable-plugins {
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }
  }
`;

interface TableOfContentLayoutProps extends React.HTMLAttributes<HTMLDivElement> {
  tocTitle?: string;
  items?: ContentItemProps[];
  editorItems?: any[];
  onItemClick?: () => void;
  scrollContainerElm?: string | Window | HTMLElement;
  currentSectionId?: string;
}

/*
 * Default template style
 *
 * */

const DefaultTemplateLayout = ({ children, tocTitle }: TableOfContentLayoutProps) => (
  <Box className="toc-layout aside">
    {tocTitle && (
      <ResponsiveTypography.Paragraph mb="16px" ellipsis={{ tooltip: true }} variant="semi-bold/16">
        {tocTitle}
      </ResponsiveTypography.Paragraph>
    )}
    {children}
  </Box>
);

const DefaultTemplate = ({
  tocTitle,
  items,
  onItemClick,
  currentSectionId,
  scrollContainerElm,
}: TableOfContentLayoutProps) => (
  <DefaultTemplateLayout tocTitle={tocTitle}>
    <TocContentLayout className="toc-content">
      {items.map((item) => (
        <ContentItemGroup
          key={item.id}
          currentSectionId={currentSectionId}
          onClick={onItemClick}
          scrollContainerElm={scrollContainerElm}
          {...item}
        />
      ))}
    </TocContentLayout>
  </DefaultTemplateLayout>
);

const DefaultTemplateWithEditor = ({
  tocTitle,
  editorItems,
  onItemClick,
  currentSectionId,
  scrollContainerElm,
}: TableOfContentLayoutProps) => (
  <DefaultTemplateLayout tocTitle={tocTitle}>
    <TocContentLayout className="toc-content">
      {editorItems.map((item) => (
        <ContentItemGroupWithEditor
          key={item.id}
          onClick={onItemClick}
          currentSectionId={currentSectionId}
          scrollContainerElm={scrollContainerElm}
          {...item}
        />
      ))}
    </TocContentLayout>
  </DefaultTemplateLayout>
);

interface ResponsiveTableOfContentProps extends TableOfContentProps {
  currentSectionId?: string;
}

export const DesktopTableOfContent = (props: ResponsiveTableOfContentProps) => {
  const { title, items, currentSectionId, scrollContainerElm, tocTitle, editorItems, ...rest } =
    props;
  const { appScrollRef } = useAppScrollRef();
  return (
    <BlogStickyTOCWrapper className="table-of-content">
      <BlogSticky
        key="table-of-content"
        scrollContainerElm={scrollContainerElm || appScrollRef.current}
        {...rest}
      >
        {Boolean(editorItems?.length) && (
          <DefaultTemplateWithEditor
            tocTitle={tocTitle}
            currentSectionId={currentSectionId}
            editorItems={editorItems}
            scrollContainerElm={scrollContainerElm || appScrollRef.current}
          />
        )}
        {Boolean(items?.length) && (
          <DefaultTemplate
            currentSectionId={currentSectionId}
            tocTitle={tocTitle}
            items={items}
            scrollContainerElm={scrollContainerElm || appScrollRef.current}
          />
        )}
      </BlogSticky>
    </BlogStickyTOCWrapper>
  );
};
